import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import legacyRunModal from 'ui-library/legacyRunModal';
import pickDefined from 'util/pickDefined';

import AnalyticsDashboardSettingsModal from './AnalyticsDashboardSettingsModal';
import {GetAnalyticsDashboard} from './graphql/__generated/GetAnalyticsDashboard';

type AnalyticsDashboard = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>;

interface AnalyticsDashboardSettingsButtonProps {
  analyticsDashboard: AnalyticsDashboard;
  className?: string;
}

export default function AnalyticsDashboardSettingsButton(
  props: AnalyticsDashboardSettingsButtonProps
): JSX.Element {
  function handleClick(): void {
    const modalProps = pickDefined(props, 'analyticsDashboard');
    legacyRunModal(AnalyticsDashboardSettingsModal, modalProps);
  }

  return (
    <Tooltip title="Dashboard settings" placement={TooltipPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className={props.className}
        icon="settings"
        onClick={handleClick}
        size={ButtonSize.SMALL}
        dataTestAttrs={{component: 'AnalyticsDashboardSettingsButton', element: 'root'}}
      />
    </Tooltip>
  );
}
